import { GetterTree } from "vuex";
import { AuthState } from "./auth.module";
import { RootState } from "..";

export const AUTH_GETTERS: GetterTree<AuthState, RootState> = {
  // get loading status
  getAuthLoading(state): boolean {
    return state.loading;
  },
  // get authentication status
  getAuthenticationStatus(state): string {
    return state.authentication;
  },
};
